(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["avista-private-payroll-main"] = factory();
	else
		root["avista-private-payroll-main"] = factory();
})(window, function() {
return 